import { Accordion, AccordionBody, AccordionHeader, Typography } from "@material-tailwind/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface FAQProps {
  id: string;
  question: string;
  answer: string;
  link?: string;
}

interface IconProps {
  open: boolean;
  id: string;
}

function Icon(props: IconProps) {
  return props.open ? (
    <>
      <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5603_9812)">
          <path d="M8.80391 5.56812C9.24195 5.56729 9.67584 5.65819 10.0808 5.83564C10.4857 6.01309 10.8538 6.2736 11.1639 6.60228L16.6106 12.3894C16.7361 12.5227 16.8066 12.7037 16.8066 12.8923C16.8066 13.0809 16.7361 13.2618 16.6106 13.3952C16.485 13.5286 16.3148 13.6035 16.1372 13.6035C15.9597 13.6035 15.7894 13.5286 15.6639 13.3952L10.2172 7.60812C9.84225 7.21017 9.33392 6.98665 8.80391 6.98665C8.27391 6.98665 7.76558 7.21017 7.39058 7.60812L1.94391 13.3952C1.81838 13.5286 1.64812 13.6035 1.47058 13.6035C1.29305 13.6035 1.12278 13.5286 0.997248 13.3952C0.871712 13.2618 0.801187 13.0809 0.801187 12.8923C0.801187 12.7037 0.871712 12.5227 0.997248 12.3894L6.44391 6.60228C6.75404 6.2736 7.1221 6.01309 7.52704 5.83564C7.93199 5.65819 8.36588 5.56729 8.80391 5.56812Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_5603_9812">
            <rect width="16" height="17" fill="white" transform="matrix(-1 0 0 -1 16.8047 17.7305)" />
          </clipPath>
        </defs>
      </svg>
    </>
  ) : (
    <>
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5581_8937)">
          <path d="M8.00077 12.1624C7.56274 12.1632 7.12885 12.0723 6.7239 11.8948C6.31896 11.7174 5.9509 11.4569 5.64077 11.1282L0.194108 5.3411C0.0685721 5.20772 -0.00195312 5.02682 -0.00195312 4.83818C-0.00195313 4.64955 0.0685721 4.46865 0.194108 4.33527C0.319644 4.20189 0.489907 4.12695 0.667441 4.12695C0.844976 4.12695 1.01524 4.20189 1.14077 4.33527L6.58744 10.1224C6.96244 10.5203 7.47077 10.7438 8.00077 10.7438C8.53078 10.7438 9.03911 10.5203 9.41411 10.1224L14.8608 4.33527C14.9863 4.20189 15.1566 4.12695 15.3341 4.12695C15.5116 4.12695 15.6819 4.20189 15.8074 4.33527C15.933 4.46865 16.0035 4.64955 16.0035 4.83818C16.0035 5.02682 15.933 5.20772 15.8074 5.3411L10.3608 11.1282C10.0506 11.4569 9.68259 11.7174 9.27765 11.8948C8.8727 12.0723 8.43881 12.1632 8.00077 12.1624Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_5581_8937">
            <rect width="16" height="17" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

function FAQComponent(props: { faq: FAQProps }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className={`flex rounded-[24px] pl-[20px] border-[2px] border-[#EEEEEE] ${open ? "bg-[#EEEEEE] border-none" : ""}`}>
      <Accordion open={open} className="border-none outline-none">
        <div className="flex items-center cursor-pointer ">
          <div onClick={() => setOpen(!open)} className="bg-#FF8136 p-[7px] rounded-full">
            <Icon id={props.faq.id} open={open} />
          </div>
          <AccordionHeader onClick={() => setOpen(!open)} className="border-none outline-none ">
            <Typography variant="h2" className="border-none outline-none ml-[13px] text-#333333 text-base 2xl:text-xl font-semibold">
              {props.faq.question}
            </Typography>
          </AccordionHeader>
        </div>
        <AccordionBody className="pl-[47px] pb-[30px] text-sm 2xl:text-lg font-light whitespace-pre-line pr-10">
          <Typography variant="h3" className="text-sm 2xl:text-lg font-light whitespace-pre-line pr-10 text-#333333">
            {props.faq.answer + ' '}
            {props.faq.link && <a className="underline cursor-pointer hover:text-#FF8136" href={props.faq.link!}>{t("Link")}</a>}
          </Typography>
        </AccordionBody>
      </Accordion>
    </div>
  );
}

export default FAQComponent;
